import { render } from "./FooterLkLeftSmall.vue?vue&type=template&id=3345600c"
import script from "./FooterLkLeftSmall.vue?vue&type=script&lang=js"
export * from "./FooterLkLeftSmall.vue?vue&type=script&lang=js"

import "./FooterLkLeftSmall.vue?vue&type=style&index=0&id=3345600c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__